export default __webpack_public_path__ + "static/media/ChristmasBanner2023Mobile.ea78a09d.png";